import React, { useEffect, useState } from "react"
import ReactExport from "react-data-export"
// import './App.css';
const ExportManifest = ({
    manifestData,
    setManifestData
}: {
    manifestData: Record<string, any>
    setManifestData: Function
}) => {
    // const [manifestData, setManifestData] = useState({} as Record<string, any>)
    const [multiDataSet, setMultiDataSet] = useState([] as Record<string, any>[])

    const ExcelFile = ReactExport.ExcelFile
    const ExcelSheet = ReactExport.ExcelFile.ExcelSheet

    let colWidths = [155, 180, 40, 70, 100, 220, 180, 60, 220, 60, 100]

    let emptyCellGenerator = (attributes: Record<string, any>) => {
        return {
            value: " ",
            style: {
                fill: {
                    patternType: "solid",
                    fgColor: { rgb: "D9D9D9" }
                },
                ...(attributes || {})
            }
        }
    }

    let borderStyleGenerator = (
        left: boolean,
        right: boolean,
        bottom: boolean,
        top: boolean,
        style?: string,
        color?: string
    ) => {
        let border = {
            top: top ? { style: style || "medium", color: color || "00000000" } : undefined,
            right: right ? { style: style || "medium", color: color || "00000000" } : undefined,
            bottom: bottom ? { style: style || "medium", color: color || "00000000" } : undefined,
            left: left ? { style: style || "medium", color: color || "00000000" } : undefined
        }
        return border
    }

    useEffect(() => {
        if (manifestData?.mawb) {
            let tempDataSet = [
                {
                    columns: [
                        { title: "  ", width: { wpx: colWidths[0] } },
                        { title: "  ", width: { wpx: colWidths[1] } },
                        { title: "  ", width: { wpx: colWidths[2] } },
                        { title: "  ", width: { wpx: colWidths[3] } },
                        { title: "  ", width: { wpx: colWidths[4] } },
                        { title: "  ", width: { wpx: colWidths[5] } },
                        { title: "  ", width: { wpx: colWidths[6] } }
                    ],
                    data: [
                        [
                            {
                                value: "FROM:",
                                style: {
                                    font: { sz: "10", bold: true, name: "Arial" },
                                    fill: {
                                        patternType: "solid",
                                        fgColor: { rgb: "D9D9D9" }
                                    },
                                    alignment: {
                                        vertical: "center",
                                        horizontal: "center"
                                    },
                                    border: { ...borderStyleGenerator(false, false, false, true) }
                                }
                            },
                            {
                                value: manifestData?.from?.toUpperCase() || "",
                                style: {
                                    font: { sz: "10", bold: true, name: "Arial" },
                                    fill: {
                                        patternType: "solid",
                                        fgColor: { rgb: "D9D9D9" }
                                    },
                                    alignment: {
                                        vertical: "center",
                                        horizontal: "left",
                                        wrapText: true
                                    },
                                    border: { ...borderStyleGenerator(false, false, false, true) }
                                }
                            },
                            emptyCellGenerator({
                                border: { ...borderStyleGenerator(false, false, false, true) }
                            }),
                            emptyCellGenerator({
                                border: { ...borderStyleGenerator(false, false, false, true) }
                            }),
                            emptyCellGenerator({
                                border: { ...borderStyleGenerator(false, false, false, true) }
                            }),
                            {
                                value: ` Flight No: ${manifestData?.flight_number || ""} `,
                                style: {
                                    font: { sz: "10", bold: true, name: "Arial" },
                                    fill: {
                                        patternType: "solid",
                                        fgColor: { rgb: "D9D9D9" }
                                    },
                                    alignment: {
                                        vertical: "center",
                                        horizontal: "center"
                                    },
                                    border: { ...borderStyleGenerator(true, true, true, true) }
                                }
                            },
                            manifestData?.country === "SA"
                                ? {
                                      value: ` No. Of Shipments: ${manifestData?.shipments_count || 0} `,
                                      style: {
                                          font: { sz: "10", bold: true, name: "Arial" },
                                          fill: {
                                              patternType: "solid",
                                              fgColor: { rgb: "D9D9D9" }
                                          },
                                          alignment: {
                                              vertical: "center",
                                              horizontal: "center"
                                          },
                                          border: { ...borderStyleGenerator(true, true, true, true) }
                                      }
                                  }
                                : emptyCellGenerator({
                                      border: { ...borderStyleGenerator(true, true, false, true) }
                                  })
                        ],
                        [
                            emptyCellGenerator({}),
                            emptyCellGenerator({}),
                            emptyCellGenerator({}),
                            emptyCellGenerator({}),
                            emptyCellGenerator({}),
                            manifestData?.country === "SA"
                                ? {
                                      value: ` MAWB No:- ${manifestData?.mawb || ""}`,
                                      style: {
                                          font: { sz: "10", bold: true, name: "Arial" },
                                          fill: {
                                              patternType: "solid",
                                              fgColor: { rgb: "D9D9D9" }
                                          },
                                          alignment: {
                                              vertical: "center",
                                              horizontal: "center"
                                          },
                                          border: { ...borderStyleGenerator(true, true, false, true) }
                                      }
                                  }
                                : emptyCellGenerator({
                                      border: { ...borderStyleGenerator(true, true, false, true) }
                                  }),
                            {
                                value:
                                    manifestData?.country === "SA"
                                        ? " No. of Pcs (Bags + Loose) "
                                        : `Orgin: ${manifestData?.origin || ""} `,
                                style: {
                                    font: { sz: "10", bold: true, name: "Arial" },
                                    fill: {
                                        patternType: "solid",
                                        fgColor: { rgb: "D9D9D9" }
                                    },
                                    alignment: {
                                        vertical: "center",
                                        horizontal: "center"
                                    },
                                    border: {
                                        ...borderStyleGenerator(
                                            true,
                                            true,
                                            false,
                                            manifestData?.country === "SA" ? true : false
                                        )
                                    }
                                }
                            }
                        ],
                        [
                            {
                                value: "TO:",
                                style: {
                                    font: { sz: "10", bold: true, name: "Arial" },
                                    fill: {
                                        patternType: "solid",
                                        fgColor: { rgb: "D9D9D9" }
                                    },
                                    alignment: {
                                        vertical: "center",
                                        horizontal: "center"
                                    }
                                }
                            },
                            {
                                value: manifestData?.to?.addressLine1?.toUpperCase() || "",
                                style: {
                                    font: { sz: "10", bold: true, name: "Arial" },
                                    fill: {
                                        patternType: "solid",
                                        fgColor: { rgb: "D9D9D9" }
                                    },
                                    alignment: {
                                        vertical: "center",
                                        horizontal: "left"
                                    }
                                }
                            },
                            emptyCellGenerator({}),
                            emptyCellGenerator({}),
                            emptyCellGenerator({}),
                            manifestData?.country !== "SA"
                                ? {
                                      value: ` MAWB No:- ${manifestData?.mawb || ""}`,
                                      style: {
                                          font: { sz: "10", bold: true, name: "Arial" },
                                          fill: {
                                              patternType: "solid",
                                              fgColor: { rgb: "D9D9D9" }
                                          },
                                          alignment: {
                                              vertical: "center",
                                              horizontal: "center"
                                          },
                                          border: { ...borderStyleGenerator(true, true, false, false) }
                                      }
                                  }
                                : emptyCellGenerator({
                                      border: { ...borderStyleGenerator(true, true, false, false) }
                                  }),
                            manifestData?.country !== "SA"
                                ? {
                                      value: ` Destination: ${manifestData?.destination || ""} `,
                                      style: {
                                          font: { sz: "10", bold: true, name: "Arial" },
                                          fill: {
                                              patternType: "solid",
                                              fgColor: { rgb: "D9D9D9" }
                                          },
                                          alignment: {
                                              vertical: "center",
                                              horizontal: "center"
                                          },
                                          border: { ...borderStyleGenerator(true, true, false, false) }
                                      }
                                  }
                                : emptyCellGenerator({
                                      border: { ...borderStyleGenerator(true, true, false, false) }
                                  })
                        ],
                        [
                            emptyCellGenerator({}),
                            {
                                value: manifestData?.to?.addressLine2?.toUpperCase() || "",
                                style: {
                                    font: { sz: "10", bold: true, name: "Arial" },
                                    fill: {
                                        patternType: "solid",
                                        fgColor: { rgb: "D9D9D9" }
                                    },
                                    alignment: {
                                        vertical: "center",
                                        horizontal: "left"
                                    }
                                }
                            },
                            emptyCellGenerator({}),
                            emptyCellGenerator({}),
                            emptyCellGenerator({}),
                            {
                                value: ` Total Pallets: ${manifestData?.pallets_count || 0}`,
                                style: {
                                    font: { sz: "10", bold: true, name: "Arial" },
                                    fill: {
                                        patternType: "solid",
                                        fgColor: { rgb: "D9D9D9" }
                                    },
                                    alignment: {
                                        vertical: "center",
                                        horizontal: "center"
                                    },
                                    border: { ...borderStyleGenerator(true, true, false, false) }
                                }
                            },
                            manifestData?.country === "SA"
                                ? {
                                      value: " Total No of PCs (including MPS) ",
                                      style: {
                                          font: { sz: "10", bold: true, name: "Arial" },
                                          fill: {
                                              patternType: "solid",
                                              fgColor: { rgb: "D9D9D9" }
                                          },
                                          alignment: {
                                              vertical: "center",
                                              horizontal: "center"
                                          },
                                          border: { ...borderStyleGenerator(true, true, false, true) }
                                      }
                                  }
                                : emptyCellGenerator({
                                      border: { ...borderStyleGenerator(true, true, false, false) }
                                  })
                        ],
                        [
                            emptyCellGenerator({}),
                            {
                                value: manifestData?.to?.addressLine3?.toUpperCase() || "",
                                style: {
                                    font: { sz: "10", bold: true, name: "Arial" },
                                    fill: {
                                        patternType: "solid",
                                        fgColor: { rgb: "D9D9D9" }
                                    },
                                    alignment: {
                                        vertical: "center",
                                        horizontal: "left"
                                    }
                                }
                            },
                            emptyCellGenerator({}),
                            emptyCellGenerator({}),
                            emptyCellGenerator({}),
                            {
                                value: ` Total Bags: ${manifestData?.bags_count || 0}`,
                                style: {
                                    font: { sz: "10", bold: true, name: "Arial" },
                                    fill: {
                                        patternType: "solid",
                                        fgColor: { rgb: "D9D9D9" }
                                    },
                                    alignment: {
                                        vertical: "center",
                                        horizontal: "center"
                                    },
                                    border: { ...borderStyleGenerator(true, true, false, false) }
                                }
                            },
                            manifestData?.country === "SA"
                                ? {
                                      value: " Total No of PCs (including MPS) ",
                                      style: {
                                          font: { sz: "10", bold: true, name: "Arial" },
                                          fill: {
                                              patternType: "solid",
                                              fgColor: { rgb: "D9D9D9" }
                                          },
                                          alignment: {
                                              vertical: "center",
                                              horizontal: "center"
                                          },
                                          border: { ...borderStyleGenerator(true, true, false, true) }
                                      }
                                  }
                                : emptyCellGenerator({
                                      border: { ...borderStyleGenerator(true, true, false, false) }
                                  })
                        ],
                        [
                            emptyCellGenerator({}),
                            emptyCellGenerator({}),
                            emptyCellGenerator({}),
                            emptyCellGenerator({}),
                            emptyCellGenerator({}),
                            manifestData?.country === "SA"
                                ? emptyCellGenerator({
                                      border: { ...borderStyleGenerator(true, true, true, false) }
                                  })
                                : {
                                      value: ` No. Of Parcels ${manifestData?.shipments_count || 0} `,
                                      style: {
                                          font: { sz: "10", bold: true, name: "Arial" },
                                          fill: {
                                              patternType: "solid",
                                              fgColor: { rgb: "D9D9D9" }
                                          },
                                          alignment: {
                                              vertical: "center",
                                              horizontal: "center"
                                          },
                                          border: { ...borderStyleGenerator(true, true, true, false) }
                                      }
                                  },
                            emptyCellGenerator({ border: { ...borderStyleGenerator(true, true, true, false) } })
                        ],
                        [
                            emptyCellGenerator({}),
                            {
                                value: manifestData?.to?.addressLine4?.toUpperCase() || "",
                                style: {
                                    font: { sz: "10", bold: true, name: "Arial" },
                                    fill: {
                                        patternType: "solid",
                                        fgColor: { rgb: "D9D9D9" }
                                    },
                                    alignment: {
                                        vertical: "center",
                                        horizontal: "left"
                                    }
                                }
                            },
                            emptyCellGenerator({}),
                            emptyCellGenerator({}),
                            emptyCellGenerator({}),
                            {
                                value: ` Flight Dep: ${manifestData?.flight_dep_date || ""} `,
                                style: {
                                    font: { sz: "10", bold: true, name: "Arial" },
                                    fill: {
                                        patternType: "solid",
                                        fgColor: { rgb: "D9D9D9" }
                                    },
                                    alignment: {
                                        vertical: "center",
                                        horizontal: "center"
                                    },
                                    border: { ...borderStyleGenerator(true, true, false, false) }
                                }
                            },
                            emptyCellGenerator({
                                border: { ...borderStyleGenerator(true, true, false, false) }
                            })
                        ],
                        [
                            emptyCellGenerator({
                                border: { ...borderStyleGenerator(false, false, true, false) }
                            }),
                            emptyCellGenerator({
                                border: { ...borderStyleGenerator(false, false, true, false) }
                            }),
                            emptyCellGenerator({
                                border: { ...borderStyleGenerator(false, false, true, false) }
                            }),
                            emptyCellGenerator({
                                border: { ...borderStyleGenerator(false, false, true, false) }
                            }),
                            emptyCellGenerator({
                                border: { ...borderStyleGenerator(false, false, true, false) }
                            }),
                            {
                                value: ` Flight Arrival: ${manifestData?.flight_arrival_date || ""}`,
                                style: {
                                    font: { sz: "10", bold: true, name: "Arial" },
                                    fill: {
                                        patternType: "solid",
                                        fgColor: { rgb: "D9D9D9" }
                                    },
                                    alignment: {
                                        vertical: "center",
                                        horizontal: "center"
                                    },
                                    border: { ...borderStyleGenerator(true, true, true, false) }
                                }
                            },
                            {
                                value: ` Weight: ${manifestData?.gross_weight || 0}`,
                                style: {
                                    font: { sz: "10", bold: true, name: "Arial" },
                                    fill: {
                                        patternType: "solid",
                                        fgColor: { rgb: "D9D9D9" }
                                    },
                                    alignment: {
                                        vertical: "center",
                                        horizontal: "center"
                                    },
                                    border: { ...borderStyleGenerator(true, true, true, false) }
                                }
                            }
                        ]
                    ]
                },
                {
                    columns: [],
                    data: []
                },
                {
                    columns: (manifestData?.columns || [])?.map((c: string, index: number) => {
                        return c
                            ? {
                                  title: `${c || ""}`,
                                  width: {
                                      wpx: colWidths[index]
                                  },
                                  style: {
                                      font: { sz: "10", bold: true, name: "Arial" },
                                      fill: {
                                          patternType: "solid",
                                          fgColor: { rgb: "FFFF00" }
                                      },
                                      alignment: {
                                          vertical: "center",
                                          horizontal: "center"
                                      },
                                      border: { ...borderStyleGenerator(true, true, true, true, "thin") }
                                  }
                              }
                            : []
                    }),
                    data: (manifestData?.data || [])?.map((r: Record<string, any>) => {
                        return Object.values(r)?.map((cell: any, index: number) => {
                            return {
                                value: `${cell || ""}`,
                                style: {
                                    font: { sz: "10", name: "Arial" },
                                    alignment:
                                        cell?.length > 0
                                            ? {
                                                  vertical: "center",
                                                  horizontal: [2, 3, 4, 6, 7, 9, 10].includes(index)
                                                      ? "center"
                                                      : "bottom"
                                              }
                                            : null,
                                    border: { ...borderStyleGenerator(true, true, true, true, "thin") }
                                }
                            }
                        })
                    })
                }
            ]
            setMultiDataSet([...tempDataSet])
        }
    }, [JSON.stringify(manifestData)])

    useEffect(() => {
        if (manifestData?.mawb && multiDataSet?.length > 0) {
            document?.getElementById("manifest-export")?.click()
            setManifestData({})
            setMultiDataSet([])
        }
    }, [JSON.stringify(manifestData), JSON.stringify(multiDataSet)])

    return (
        <div>
            <ExcelFile
                filename={`manifest-${manifestData?.mawb}`}
                element={<button id="manifest-export">Download Data With Styles</button>}>
                <ExcelSheet dataSet={multiDataSet} name={manifestData?.mawb} />
            </ExcelFile>
        </div>
    )
}

export default ExportManifest
